var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPhone = function SvgPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m21.27 16.356-2.13-2.132a2.44 2.44 0 0 0-2.683-.542c-.298.126-.569.31-.796.542l-.426.426a47 47 0 0 1-5.92-5.92l.434-.435a2.465 2.465 0 0 0 0-3.482L7.645 2.707a2.494 2.494 0 0 0-3.478 0L3.002 3.873a3.484 3.484 0 0 0-.434 4.353 47.2 47.2 0 0 0 13.19 13.206 3.475 3.475 0 0 0 4.346-.436l1.165-1.157a2.44 2.44 0 0 0 .54-2.686 2.4 2.4 0 0 0-.54-.797"
  })));
};
export default SvgPhone;